var poll_default = {
  "fontElementMap": "_5OiqM",
  "container": "aed1Y",
  "fullscreen": "MLhOr",
  "background_overlay": "H6udH",
  "with_image": "UOiV7",
  "options": "pk7NN",
  "webview": "XIzM-",
  "grid": "OQK3L",
  "option": "Kbfug",
  "cta_button": "NZFTP",
  "add_option": "rC6lH",
  "see_more": "mp4tR",
  "list": "Wg99-",
  "column": "_6EluR",
  "additional_note": "wUZQf",
  "spinner": "LJt2k",
  "spin": "_5mpHI",
  "shown": "N2bR8",
  "error": "YgAOE"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
